import { useEffect, useState } from 'react';
import { Input, InputGroup, Tooltip, Button, Menu, UnitInput } from '@oliasoft-open-source/react-ui-library';
import { useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { linkFields as lengthLinkFields, AllLinkFieldsType } from 'src/enums/settings';
import { GroupOrderType } from 'src/enums/general';
import translations from 'src/internationalisation/translation-map.json';
import { withErrorBoundary } from '@oliasoft-open-source/react-ui-library';

const RawInputWithVariable = ({
  width = '180px',
  name,
  control,
  unit,
  unitkey = '',
  errors = {},
  error = null,
  noConversion = false,
  linkFields = lengthLinkFields,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const { field } = useController({
    name,
    control,
  });

  const { onChange, value, ...props } = field;
  const [peredefinedOption, setPredefinedOption] = useState(linkFields.CUSTOM);
  const getDisplayValue = (val) => {
    if (val === AllLinkFieldsType.SECTION_LENGTH) {
      return t(translations.costSetup_tubularLength);
    }
    if (val === AllLinkFieldsType.ANNULUS_VOLUME) {
      return t(translations.costSetup_annularCementVolume);
    }
    return val;
  };
  useEffect(() => {
    if (Object.values(linkFields).includes(value)) {
      setPredefinedOption(value);
      onChange(value);
    } else {
      setPredefinedOption(linkFields.CUSTOM);
      onChange(value);
    }
  }, [value]);
  const predefinedMenuItems = Object.values(linkFields).map((value) => ({
    type: 'Option',
    inline: true,
    onClick: () => {
      setPredefinedOption(value);
      onChange(value === linkFields.CUSTOM ? `0|${unit}` : value);
    },
    label: getDisplayValue(value),
    description: '',
    selected: value === peredefinedOption,
  }));
  return (
    <InputGroup width={width}>
      <Menu
        colored
        maxHeight={380}
        groupOrder={GroupOrderType.FIRST}
        menu={{
          trigger: 'Component',
          component: (
            <Tooltip text={getDisplayValue(peredefinedOption)}>
              <Button
                groupOrder={GroupOrderType.FIRST}
                icon={peredefinedOption === linkFields.CUSTOM ? 'unlink' : 'link'}
              />
            </Tooltip>
          ),
          sections: predefinedMenuItems,
        }}
      />
      {peredefinedOption === linkFields.CUSTOM && !Object.values(linkFields).includes(value) && (
        <UnitInput
          {...props}
          onChange={onChange}
          value={value}
          unitkey={unitkey}
          initUnit={unit}
          error={translations[errors[name]] ? t(errors[name]) : errors[name] || error}
          noConversion={noConversion}
          disabled={disabled}
        />
      )}
      {peredefinedOption !== linkFields.CUSTOM && <Input {...props} value={getDisplayValue(value)} disabled={true} />}
    </InputGroup>
  );
};

export const InputWithVariable = withErrorBoundary(RawInputWithVariable);
